export enum GridSortDirection {
  Ascending = 'asc',
  Descending = 'desc',
}
